import { Box, useTheme } from '@mui/system'
import React from 'react'
import { PaymentState } from '../../services/api/sharedTypes/Common'
import { convertPaymentStateTypeToString } from '../../utils/event-utils'

interface PaymentStateTagProps {
    paymentState: PaymentState
}

const PaymentStateTag: React.FC<PaymentStateTagProps> = ({ paymentState }: PaymentStateTagProps) => {
    const theme = useTheme()

    if (paymentState === PaymentState.NotSet) return null

    return (
        <Box
            p={1}
            borderRadius='5px'
            textAlign='center'
            style={
                paymentState === PaymentState.NotPaid
                    ? {
                          color: theme.palette.customBackground.default,
                          backgroundColor: theme.palette.error.light,
                      }
                    : {
                          color: theme.palette.text.primary,
                          backgroundColor: theme.palette.success.light,
                      }
            }
        >
            {convertPaymentStateTypeToString(paymentState)}
        </Box>
    )
}

export default PaymentStateTag
